import { createContext, useContext } from 'react';
import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import nbNo from '../resources/HN.CoreFrontend.NPM.Packages.CMS.CookieBanner.nb-NO.json';
export const getResources = (language) => {
    switch (language) {
        case LanguageLocales.NORWEGIAN:
        default:
            return nbNo;
    }
};
const ResourceContext = createContext(getResources(LanguageLocales.NORWEGIAN));
export const ResourceContextProvider = ResourceContext.Provider;
export const useResources = () => {
    const context = useContext(ResourceContext);
    if (!context) {
        throw new Error('useResources must be used within a ResourceContextProvider');
    }
    return context;
};
